import { default as _91_46_46_46route_9387BeCENduzMeta } from "/builds/webcontact/burgbernheim/pages/[...route].vue?macro=true";
import { default as indexxmuc4Bq5ftMeta } from "/builds/webcontact/burgbernheim/pages/index.vue?macro=true";
export default [
  {
    name: "route",
    path: "/:route(.*)*",
    component: () => import("/builds/webcontact/burgbernheim/pages/[...route].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/webcontact/burgbernheim/pages/index.vue")
  }
]